if (!customElements.get('academy-timeline')) {
  class AcademyTimeline extends HTMLElement {
    connectedCallback() {
      this.navBtns = this.querySelectorAll('.academy-timeline__nav-btn');
      this.panels = this.querySelectorAll('.academy-timeline__panel');

      this.navBtns.forEach((btn) => {
        btn.addEventListener('click', () => this.activate(btn.dataset.year));
      });
    }

    activate(year) {
      this.navBtns.forEach((btn) => {
        const active = btn.dataset.year === year;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-selected', active);
      });

      this.panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.year === year);
      });

      // Scroll active nav button into view on mobile
      const activeBtn = this.querySelector(`.academy-timeline__nav-btn[data-year="${year}"]`);
      activeBtn?.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  customElements.define('academy-timeline', AcademyTimeline);
}
